import type { Certification } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import useSWR, { type SWRResponse } from "swr";

const useCertification = (certificationSlug?: string) => {
	const router = useRouter();

	const { certificationSlug: routeSlug } = router?.query || {};

	const slug = certificationSlug || routeSlug;

	const {
		data: certification,
		error,
		mutate,
		isLoading,
		...rest
	} = useSWR(
		slug && `/certifications/${slug}`,
		{},
	) as SWRResponse<Certification> & {
		data: Certification;
	};

	return {
		certification,
		refetchCertification: mutate,
		isLoading,
		...rest,
	};
};

export default useCertification;
